import { useLocation, Location } from "react-router";
import { PageBody } from "../../../components/pages/PageBody";
import { Typography } from "../../../components/atoms/Typography";
import styled from "styled-components";
import { useCheckUserRole } from "../../../hooks";

export const PrescriptionCancelErrorPage = () => {
  useCheckUserRole();

  const location: Location<{
    message: string;
    prescriptionCode: string;
  }> = useLocation();
  const { message, prescriptionCode } = location.state;

  const RowWrapper = styled.div`
    min-height: 58px;
    padding: 10px 5px 10px 0;
    ${({ theme }) => `border-bottom: 1px solid ${theme.colors.primaryBorder};`}
    p {
      margin-top: 10px;
    }
  `;

  const ContentWrapper = styled.div`
    padding: 0 40px;
    clear: both;
  `;
  return (
    <>
      <PageBody title={"処方キャンセルに失敗しました"}>
        <ContentWrapper>
          <RowWrapper>
            <Typography size={2}>エラーメッセージ: {message}</Typography>
            <Typography size={2}> 処方コード: {prescriptionCode}</Typography>
            <Typography size={2}>
              上記情報と一緒にDTFチームへご連絡ください
            </Typography>
          </RowWrapper>
        </ContentWrapper>
      </PageBody>
    </>
  );
};
